module.exports = __webpack_public_path__ + "media/app/assets/kappa-91ae03e1b9e5a5a93d5f64e190d7d6e9.png";